export const showAll = () => {
  const showAllInit = (showAllSelection: HTMLElement) => {
    /* unique Id of current show all area */
    const showAllId = showAllSelection.id;

    /* Get button, all items that would potentially hide/show, and the initial amount that should be shown */
    const showAllBtn = document.querySelector<HTMLButtonElement>(
      `#${showAllId} [js-show-all--button]`
    );
    const showLessBtn = document.querySelector<HTMLButtonElement>(
      `#${showAllId} [js-show-less--button]`
    );
    const items = document.querySelectorAll<HTMLElement>(
      `#${showAllId} [js-show-all--item]`
    );
    const initialAmount = document
      .querySelector<HTMLElement>(`#${showAllId}`)
      ?.getAttribute("js-show-all--amount");

    /* If any are not set, return */
    if (!showAllBtn || !items || !initialAmount) {
      return;
    }

    /* Loop through array of items and hide any that have a higher key than the initial amount shown */
    for (let i = +initialAmount; i < items.length; i++) {
      items[i].classList.add("hidden");
    }

    /* Clicked 'show all' button, show all the hidden items and toggle the buttons */
    showAllBtn.addEventListener("click", function () {
      items.forEach((i) => i.classList.remove("hidden"));
      showAllBtn.classList.add("hidden");

      if (!showLessBtn) {
        return;
      }

      showLessBtn.classList.remove("hidden");
    });

    /* Clicked 'show less' button, hide all the items that were hidden on page load */
    showLessBtn?.addEventListener("click", function () {
      items.forEach((i, index) => {
        if (index >= +initialAmount) {
          i.classList.add("hidden");
        }
      });
      showAllBtn.classList.remove("hidden");
      showLessBtn.classList.add("hidden");
    });
  };

  /* Get all show all areas on page */
  const showAllSections =
    document.querySelectorAll<HTMLElement>("[js-show-all]");

  /* Loop over all of the show all areas and apply functionality on each one */
  showAllSections.length > 0
    ? showAllSections.forEach((showAllSection) => showAllInit(showAllSection))
    : null;
};
